import { render } from "./ActivateAi.vue?vue&type=template&id=3bfed5f8&scoped=true"
import script from "./ActivateAi.vue?vue&type=script&lang=ts"
export * from "./ActivateAi.vue?vue&type=script&lang=ts"

import "./ActivateAi.vue?vue&type=style&index=0&id=3bfed5f8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3bfed5f8"

export default script